<template>
  <textarea class="input" @input="onChange" :value="value">
  </textarea>
</template>

<script>
import autosize from 'autosize'

export default {
  name: 'ima-autosize-textarea',
  props: ['value'],
  data () {
    return {}
  },
  methods: {
    onChange (event) {
      this.$emit('input', event.target.value)
    }
  },
  mounted () {
    autosize(this.$el)
  }
}
</script>

<style>
textarea {
  resize: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/AutoSizeTextArea.vue